// Library
import { defineStyleConfig } from '@chakra-ui/react';

export const Text = defineStyleConfig({
  baseStyle: {
    fontFamily: '"Jost", sans-serif',
    fontSize: 'xs',
    fontWeight: 'normal',
    lineHeight: 'normal',
    color: 'text.dark',
  },
  variants: {
    faded: {
      color: 'text.faded',
    },
  },
});
